import classNames from 'classnames';
import styles from './modal-container.module.scss';
import ScrollableContentIndicator from '../../../../general/scrollable-content-indicator/scrollable-content-indicator';

type Props = {
  height: string;
  width: string;
  children: React.ReactNode;
  isScrollableContentIndicatorOn: boolean | null | undefined;
};

type State = {
  showGradient: boolean;
};

class ModalContainer extends React.Component<Props, State> {
  state: State = {
    showGradient: false,
  };

  static defaultProps = {
    height: 'tall',
    width: 'wide',
    isScrollableContentIndicatorOn: false,
  };

  modal = React.createRef<HTMLDivElement>();

  toggleGradient = () => {
    const { showGradient } = this.state;
    const { isMobile } = context.viewport;
    const breakpoint = isMobile ? 270 : 80;

    if (this.modal.current) {
      if (!showGradient && this.modal.current.scrollTop > breakpoint) {
        this.setState({ showGradient: true });
      } else if (showGradient && this.modal.current.scrollTop <= breakpoint) {
        this.setState({ showGradient: false });
      }
    }
  };

  render() {
    const { children, height, width, isScrollableContentIndicatorOn } =
      this.props;
    const { showGradient } = this.state;
    return (
      <ScrollableContentIndicator disabled={!isScrollableContentIndicatorOn}>
        {observableDiv => (
          <div
            ref={this.modal}
            onScroll={this.toggleGradient}
            className={classNames(styles[height], styles[width], styles.modal)}
          >
            <div className={styles['gradient-wrapper']}>
              <div
                className={classNames(
                  styles.gradient,
                  !showGradient && styles['gradient--hidden'],
                )}
              />
            </div>

            {children}

            {isScrollableContentIndicatorOn && (
              <div ref={observableDiv} className={styles[`observable-div`]} />
            )}
          </div>
        )}
      </ScrollableContentIndicator>
    );
  }
}

export default ModalContainer;
